import type { CheckoutPolicies } from '@wix/ambassador-ecom-v1-ecommerce-settings/types';
import type { EcommerceSettingsService } from '../../../../services/ecommerce-settings-service/EcommerceSettingsService';
import type { EcomPlatformViewerScriptContext } from '../../../../viewer-script/types';
import type { ExpressCheckoutSettings } from '../../../types';

export class ExpressCheckoutSettingsService {
  static fromContext(
    context: EcomPlatformViewerScriptContext,
  ): ExpressCheckoutSettingsService {
    return new ExpressCheckoutSettingsService(context.eCommerceSettingsService);
  }

  constructor(
    private readonly eCommerceSettingsService:
      | EcommerceSettingsService
      | undefined,
  ) {}

  public readonly getSettings = async (): Promise<ExpressCheckoutSettings> => {
    const ecommerceSettings =
      await this.eCommerceSettingsService?.getEcommerceSettings();
    const checkoutPolicies =
      ecommerceSettings?.checkoutSettings?.checkoutPolicies;
    return {
      taxOnProduct: Boolean(ecommerceSettings?.tax?.taxIncludedInItemPrices),
      isExpressSupported:
        !ecommerceSettings?.checkoutSettings?.checkoutFields
          ?.delayCaptureEnabled,
      hasPolicies: this.hasAnyCheckoutPolicy(checkoutPolicies),
      requirePolicyAgreement: Boolean(
        ecommerceSettings?.checkoutSettings?.checkoutFields
          ?.policyAgreementCheckbox?.visible,
      ),
      isPremium: Boolean(ecommerceSettings?.isPremium),
      canBusinessShip:
        (ecommerceSettings?.delivery?.countries?.length ?? 0) > 0 ||
        !!ecommerceSettings?.delivery?.restOfWorld,
    };
  };

  private readonly hasAnyCheckoutPolicy = (
    checkoutPolicies?: CheckoutPolicies,
  ): boolean => {
    const policies = [
      checkoutPolicies?.termsAndConditions,
      checkoutPolicies?.privacyPolicy,
      checkoutPolicies?.returnPolicy,
      checkoutPolicies?.digitalItemPolicy,
      checkoutPolicies?.customPolicy,
    ];
    return policies.some(
      (policy) => policy?.visible === true && Boolean(policy?.content?.trim()),
    );
  };
}
